import { graphql } from 'react-relay';

export const myInfo = graphql`
  query myInfoQuery {
    bznavRefund {
      user {
        email
        phone
        name
        lastLoginType
        createdAt
      }
    }
    checkUserLeave {
      canLeave
    }
  }
`;
